import type { ThemeChoice } from "../types/index.js";

export const themeChoices: ThemeChoice[] = ["os", "dark", "light"];
